import type { PropsWithChildren } from "react";
import { StyleSheet, View, type ViewStyle } from "react-native";

const styles = StyleSheet.create({
  queueFade: {
    flex: 1,
    maskImage:
      "linear-gradient(to bottom, black 0%, black 82%, transparent 87%, transparent 100%)",
  } as ViewStyle,
});

const QueueFadeMask = ({ children }: PropsWithChildren) => (
  <View style={styles.queueFade} testID="options-queue-fade">
    {children}
  </View>
);

export default QueueFadeMask;
